import React, { useEffect, useState } from 'react';
import { connect, useSelector } from 'react-redux';
import { injectIntl, intlShape } from 'react-intl';
import '../../node_modules/react-multi-carousel/lib/styles.css';
import PropTypes from 'prop-types';
import {
    Container, Typography, Grid, Box,
    Divider, useTheme, useMediaQuery
} from '@mui/material';
import { List as IList, Map as IMap } from 'immutable';
import Alert from '@mui/material/Alert';

import Markdown from 'markdown-to-jsx';
import DOMPurify from 'dompurify';
import windowSize from '../utils/windowSize';
import CategoryTabsCarouselContainer from './CategoryPage/CategoryTabsCarouselContainer';
import { getFormattedAmountWithCurrency } from '../utils/numberUtils';
import { PHYSICAL_CARD_TYPE } from '../productCartHandler/productCartModule';
import {
    saveSelectedCardOnBuyButtonClick, categoryDropdownSelectClick, selectedCardType, setClickedOnUYO
} from '../landingPage/landingPageModule';
import homePageV2Messages from './assets/messages/homePageMessages';
import SkeletonLoader from '../loader/SkeletonLoader';
import SiteSwitchDialog from '../localeCurrencyPicker/SiteSwitchDialog';
import { getCartCurrencyCode, getRemainingPlasticCardsAllowed } from '../productCartHandler/productCartSelectors';
import {
    getBrandElectronicCurrencyList,
    getBrandPlasticCurrencyList,
    getCartMaxNumPlasticCards, getEgcRangedCatalogForCurrency, getFixedEgcCatalogForCurrency,
    getFixedPlasticCatalogForCurrency, getIsFixedEgcCatalogPresentForCurrency,
    getIsFixedPlasticCatalogPresentForCurrency, getPlasticRangedCatalogForCurrency, getUYOEgcPhotoSupported,
    getUYOPlasticPhotoSupported
} from '../brand/brandSelectors';
import { CARD_TYPES } from '../constants/constants';
import DenomCurrencyPicker from '../giftCardDetailsPage_v2/DenomCurrencyPicker';
import {
    getCheckOutSubHeaderTextDigital,
    getCheckOutSubHeaderTextPhysical, getCheckOutSubHeaderTextPrintAtHome,
    getIntlCurrencyCode
} from '../intl/intlSelectors';
import { setCurrency as setCurrencyActionCreator } from '../intl/intlModule';
import { getSelectedFaceplate } from '../landingPage/landingPageSelectors';
import { trackButtonClick } from '../segment/segmentModule';
import { HOME_STEP } from '../routing/flowConstants';
import giftCardDetailsPageMessagesV2 from '../giftCardDetailsPage_v2/messages/giftCardDetailsPageMessages';
import NewFeatureBullet from './NewFeatureBullet';
import { digitalHighlightBulletLists } from './DigitalHighlightBulletLists';
import { printAtHomeHighlightBulletLists } from './PrintAtHomeHighlightBulletLists';
import { physicalHighlightBulletLists } from './PhysicalHighlightBulletLists';
import { getFormattedMessage } from '../utils/textUtils';

const LandingPageFaceplateContainer = ({
    categories,
    handleSubmit,
    intl,
    giftCardDeliveryType,
    submitButtonName,
    digitalPrimaryFaceplate,
    saveSelectedCardOnBuyButtonClickAction,
    isLoading,
    categoryDropdownSelectClickAction,
    remainingPlasticCardsAllowed,
    cartMaxNumPlasticCards,
    physicalPrimaryFacePlate,
    selectedCurrency,
    supportedElectronicCurrencyList,
    supportedPlasticCurrencyList,
    setCurrency,
    cartCurrencyCode,
    uyoEgcPhotoSupported,
    uyoPlasticPhotoSupported,
    selectedFaceplate,
    setClickedOnUYOAction,
    cardType,
    tempCurrency,
    setTempCurrency,
    trackSegmentButtonClick,
    checkoutSubHeaderTextDigital,
    checkoutSubHeaderTextPhysical,
    checkoutSubHeaderTextPrintAtHome
}) => {
    const theme = useTheme();
    const isMobileView = useMediaQuery(theme.breakpoints.down('sm'));
    const [isMaxPhysicalItemModalOpen, setIsMaxPhysicalItemModalOpen] = useState(false);

    const handleMaxLimitModalClose = value => setIsMaxPhysicalItemModalOpen(value);
    const [openNewFeatureDialog, setOpenNewFeatureDialog] = useState(false);

    
    const categoryCount = categories.count();
    const [faceplatesCount, setFaceplatesCount] = useState(null);

    const [isDialogOpen, setDialogOpen] = React.useState(false);
    const handleCloseModel = value => setDialogOpen(value);

    const isPhysicalCard = giftCardDeliveryType === PHYSICAL_CARD_TYPE;
    const cardDeliveryType = isPhysicalCard ? CARD_TYPES.Physical : CARD_TYPES.Digital;

    const isPhotoSupported = isPhysicalCard ? uyoPlasticPhotoSupported : uyoEgcPhotoSupported;
    const [uyoFaceplate, setUyoFaceplate] = useState(null);
    useEffect(() => {
    
        if (selectedFaceplate.get('imageURL')?.includes('ucarecdn.com')) {
            setUyoFaceplate(selectedFaceplate);
        }
    }, [selectedFaceplate]);

    
    const currencyList = isPhysicalCard ? supportedPlasticCurrencyList : supportedElectronicCurrencyList;
    const currencyExistsInList = currencyList.includes(selectedCurrency);

    const hidePicker = cartCurrencyCode && !currencyExistsInList;

    const hideDenomPicker = supportedPlasticCurrencyList.size <= 1 && supportedElectronicCurrencyList.size <= 1;

    
    const isSetCurrency = false;

    const isFixedCatalog = isPhysicalCard ? useSelector(getIsFixedPlasticCatalogPresentForCurrency(tempCurrency))
        : useSelector(getIsFixedEgcCatalogPresentForCurrency(tempCurrency));
    let catalogRange;
    if (isFixedCatalog) {
        catalogRange = isPhysicalCard ? useSelector(getFixedPlasticCatalogForCurrency(tempCurrency))
            : useSelector(getFixedEgcCatalogForCurrency(tempCurrency));
    } else {
        catalogRange = isPhysicalCard ? useSelector(getPlasticRangedCatalogForCurrency(tempCurrency))
            : useSelector(getEgcRangedCatalogForCurrency(tempCurrency));
    }

        const defaultFaceplate = isPhysicalCard
        ? physicalPrimaryFacePlate
        : digitalPrimaryFaceplate;
    const defaultCategory = categories.get(0);

    
    const CTAButtonOnClick = (faceplate, submitButtonTitleName, isPhysicalCardType, isMaxPhysicalModelOpen = false) => {
        if (!isMaxPhysicalModelOpen) {
            setCurrency(tempCurrency);
        }
        
        saveSelectedCardOnBuyButtonClickAction(defaultCategory,
            faceplate,
            submitButtonTitleName,
            isPhysicalCardType);
        setClickedOnUYOAction(false);
        handleSubmit(isPhysicalCardType);
    };
    const catalogStartRange = isFixedCatalog ? catalogRange && Number(catalogRange.get(0))
        : catalogRange && Number(catalogRange.get('start'));
    const catalogEndRange = isFixedCatalog ? Number(catalogRange.get(catalogRange.size - 1))
        : catalogRange && Number(catalogRange.get('end'));

    const handleCloseNewFeatureModel = () => {
        setOpenNewFeatureDialog(false);
    };


    const numberOfOptionsToShow = (faceplatesCount > 1 || categoryCount > 1) ? 3 : 4;
    let sortedCardDeliveryTypeOptionsList = digitalHighlightBulletLists(intl);
    let checkoutSubHeaderText = checkoutSubHeaderTextDigital || '';
    let newFeatureSummaryText = getFormattedMessage(
        intl, giftCardDetailsPageMessagesV2.newFeatureSummaryTextDigital
    );
    let newFeaturePopUpTitle = intl.formatMessage(
        giftCardDetailsPageMessagesV2.newFeaturePopUpTitleDigital
    );
    let newFeaturePopUpDescriptionText = intl.formatMessage(
        giftCardDetailsPageMessagesV2.newFeaturePopUpDescriptionDigital
    );
    if (cardType === CARD_TYPES.PrintAtHome) {
        sortedCardDeliveryTypeOptionsList = printAtHomeHighlightBulletLists(intl);
        checkoutSubHeaderText = checkoutSubHeaderTextPrintAtHome || '';
        newFeatureSummaryText = getFormattedMessage(
            intl, giftCardDetailsPageMessagesV2.newFeatureSummaryTextPrintAtHome
        );
        newFeaturePopUpTitle = intl.formatMessage(
            giftCardDetailsPageMessagesV2.newFeaturePopUpTitlePrintAtHome
        );
        newFeaturePopUpDescriptionText = intl.formatMessage(
            giftCardDetailsPageMessagesV2.newFeaturePopUpDescriptionPrintAtHome
        );
    } else if (cardType === CARD_TYPES.Physical) {
        sortedCardDeliveryTypeOptionsList = physicalHighlightBulletLists(intl);
        checkoutSubHeaderText = checkoutSubHeaderTextPhysical || '';
        newFeatureSummaryText = getFormattedMessage(
            intl, giftCardDetailsPageMessagesV2.newFeatureSummaryTextPlastic
        );
        newFeaturePopUpTitle = intl.formatMessage(
            giftCardDetailsPageMessagesV2.newFeaturePopUpTitlePlastic
        );
        newFeaturePopUpDescriptionText = intl.formatMessage(
            giftCardDetailsPageMessagesV2.newFeaturePopUpDescriptionPlastic
        );
    }

    const handleIconClick = () => {
        setOpenNewFeatureDialog(true);
        trackSegmentButtonClick(`${cardType} GC : Info button`, HOME_STEP, 'Homepage NEW callout info');
    };

    
    const callbackOnCategorySelectOrClose = (categoryDropdownClickData) => {
        categoryDropdownSelectClickAction(categoryDropdownClickData);
    };

    
    const CatalogRangeBlock = () => {
        const minRangeString = catalogRange
            && getFormattedAmountWithCurrency(intl, catalogStartRange, tempCurrency);
        const maxRangeString = catalogRange
            && getFormattedAmountWithCurrency(intl, catalogEndRange, tempCurrency);

        return (
            (!Number.isNaN(catalogStartRange) || !Number.isNaN(catalogEndRange))
                ? (
                    <>
                        { !hideDenomPicker && (
                            <Divider
                                component="span"
                                orientation="vertical"
                                flexItem
                                className="custom-vertical-divider"
                                sx={{ display: { xs: 'block', sm: 'block' } }}
                            />
                        )}
                        <Typography>
                            {minRangeString}
                            —
                            {maxRangeString}
                        </Typography>
                    </>
                )
                : null
        );
    };

    
    const renderCatalogAndDenom = () => (
        <Grid
            item
            xs={12}
            sm='auto'
            className='description-container catalog-range-block'
        >
            <SkeletonLoader
                isLoading={isLoading}
                skeletonProps={{
                    animation: 'wave',
                    variant: 'text',
                    className: 'skeletonclass',
                    height: 40,
                    width: 100
                }}
            >
                { !hidePicker && (
                    <>
                        { !hideDenomPicker && (
                            <DenomCurrencyPicker
                                cardDeliveryType={cardDeliveryType}
                                tempCurrency={tempCurrency}
                                setTempCurrency={setTempCurrency}
                                isSetCurrency={isSetCurrency}
                            />
                        )}
                        <CatalogRangeBlock />
                    </>
                )}
            </SkeletonLoader>
        </Grid>
    );

    return (
        <>
            <Container className='LandingPageFaceplateContainer'>
                {(faceplatesCount > 1 || categoryCount > 1) && (
                    <Grid container className='gift-card-title-catalog-wrapper'>
                        <Grid item sx={12} sm={12}>

                            {isMobileView && checkoutSubHeaderText.trim() && (
                                <Grid item xs={12} className='mobile-checkout-sub-header-text'>
                                    <Typography
                                        className='landing-page-description-text'
                                        variant='body2'
                                        component='p'
                                    >
                                        <Markdown>
                                            {DOMPurify.sanitize(checkoutSubHeaderText)}
                                        </Markdown>
                                    </Typography>
                                </Grid>
                            )}


                            <Grid
                                container
                                className={`toggle-description-grid${!newFeatureSummaryText.trim() ? ' no-new-feature-callout' : ''}`}
                                alignItems="flex-start"
                            >
                                <Grid
                                    item
                                    xs={12}
                                    className={`sub-header-new-container${isMobileView ? ' mobile-sub-header-new-container' : ''}`}
                                >
                                    <Grid
                                        item
                                        xs={12}
                                        sm='auto'
                                        className='toggle-description-container'
                                    >
                                        {checkoutSubHeaderText.trim() && (
                                            <Grid item xs={12} className="checkout-sub-header-text">
                                                <Typography
                                                    className='landing-page-description-text'
                                                    variant='body2'
                                                    component='p'
                                                >
                                                    <Markdown>
                                                        {DOMPurify.sanitize(checkoutSubHeaderText)}
                                                    </Markdown>
                                                </Typography>
                                            </Grid>
                                        )}
                                        {newFeatureSummaryText.trim()
                                                && (
                                                    <Grid container className='toggle-description-container-inner-grid'>
                                                        <Grid item xs={12}>
                                                            <NewFeatureBullet
                                                                intl
                                                                newFeatureSummaryText={newFeatureSummaryText}
                                                                newFeaturePopUpTitle={newFeaturePopUpTitle}
                                                                newFeaturePopUpDescriptionText={newFeaturePopUpDescriptionText}
                                                                openNewFeatureDialog={openNewFeatureDialog}
                                                                handleIconClick={handleIconClick}
                                                                handleCloseNewFeatureModel={handleCloseNewFeatureModel}
                                                            />
                                                        </Grid>
                                                    </Grid>
                                                )}
                                    </Grid>


                                    {renderCatalogAndDenom()}
                                </Grid>

                                <Grid item xs={12} className='eco-friendly-delivery-container'>
                                    <SkeletonLoader
                                        isLoading={isLoading}
                                        skeletonProps={{
                                            animation: 'wave',
                                            variant: 'rectangular',
                                            className: 'skeletonclass',
                                            width: '100%',
                                            height: 50
                                        }}
                                    >
                                        <ul className='eco-friendly-delivery-list'>
                                            {sortedCardDeliveryTypeOptionsList.slice(
                                                0, numberOfOptionsToShow
                                            ).map(item => (
                                                <li className='description-container' key={item.text}>
                                                    <span className='eco-Friendly-icon'>
                                                        {item.icon}
                                                    </span>
                                                    <Typography component="span" className='eco-Friendly-Label'>
                                                        {item.text}
                                                    </Typography>
                                                </li>
                                            ))}
                                        </ul>
                                    </SkeletonLoader>
                                </Grid>

                            </Grid>

                        </Grid>

                    </Grid>
                )}
                {
                    hidePicker
                    && (
                        <Alert severity="error" className='currency-not-exists-in-list'>
                            {intl.formatMessage(homePageV2Messages.currencyNotExistsInList,
                                { cardDeliveryType, selectedCurrency })}
                        </Alert>
                    )
                }
                <Box>
                    {}
                    <CategoryTabsCarouselContainer
                        categories={categories}
                        handleSubmit={handleSubmit}
                        giftCardDeliveryType={giftCardDeliveryType}
                        categoryCount={categoryCount}
                        faceplatesCount={faceplatesCount}
                        setFaceplatesCount={setFaceplatesCount}
                        isLoading={isLoading}
                        callbackOnCategorySelectOrClose={callbackOnCategorySelectOrClose}
                        tempCurrency={tempCurrency}
                        shouldSetCurrency={!hidePicker}
                        cardType={cardType}
                        renderCatalogAndDenom={renderCatalogAndDenom}
                        isNewLandingPage 
                        isPhotoSupported={isPhotoSupported}
                        isPhysicalCard={isPhysicalCard}
                        uyoFaceplate={uyoFaceplate}
                        defaultCategory={defaultCategory}
                        defaultFaceplate={defaultFaceplate}
                        hidePicker={hidePicker}
                    />
                </Box>
            </Container>
            {isDialogOpen && (
                <SiteSwitchDialog
                    physicalCard
                    isOpen={isDialogOpen}
                    handleCloseModel={handleCloseModel}
                />
            )}
            {isMaxPhysicalItemModalOpen && (
                <SiteSwitchDialog
                    physicalCard
                    isOpen={isMaxPhysicalItemModalOpen}
                    handleCloseModel={handleMaxLimitModalClose}
                    isPhysicalcartMaxlimitReached={isMaxPhysicalItemModalOpen}
                    onConfirmCTA={() => CTAButtonOnClick(remainingPlasticCardsAllowed === 0
                        ? digitalPrimaryFaceplate : defaultFaceplate, submitButtonName, false)
                    }
                    cartMaxNumPlasticCards={cartMaxNumPlasticCards}
                />
            )}
        </>
    );
};

LandingPageFaceplateContainer.defaultProps = {
    giftCardDeliveryType: '',
    submitButtonName: '',
    digitalPrimaryFaceplate: IMap(),
    categories: IList(),
    cartMaxNumPlasticCards: 0,
    physicalPrimaryFacePlate: IMap(),
    uyoEgcPhotoSupported: false,
    uyoPlasticPhotoSupported: false,
    cardType: 'Digital',
    checkoutSubHeaderTextDigital: '',
    checkoutSubHeaderTextPhysical: '',
    checkoutSubHeaderTextPrintAtHome: ''
};

LandingPageFaceplateContainer.propTypes = {
    categories: PropTypes.instanceOf(IList),
    handleSubmit: PropTypes.func.isRequired,
    intl: intlShape.isRequired,
    giftCardDeliveryType: PropTypes.string,
    submitButtonName: PropTypes.string,
    digitalPrimaryFaceplate: PropTypes.instanceOf(IMap),
    saveSelectedCardOnBuyButtonClickAction: PropTypes.func.isRequired,
    categoryDropdownSelectClickAction: PropTypes.func.isRequired,
    isLoading: PropTypes.bool.isRequired,
    remainingPlasticCardsAllowed: PropTypes.number.isRequired,
    cartMaxNumPlasticCards: PropTypes.number,
    physicalPrimaryFacePlate: PropTypes.instanceOf(IMap),
    selectedCurrency: PropTypes.string.isRequired,
    supportedElectronicCurrencyList: PropTypes.instanceOf(IList).isRequired,
    supportedPlasticCurrencyList: PropTypes.instanceOf(IList).isRequired,
    setCurrency: PropTypes.func.isRequired,
    cartCurrencyCode: PropTypes.string.isRequired,
    selectedFaceplate: PropTypes.instanceOf(IMap).isRequired,
    uyoEgcPhotoSupported: PropTypes.bool,
    uyoPlasticPhotoSupported: PropTypes.bool,
    cardType: PropTypes.string,
    setClickedOnUYOAction: PropTypes.func.isRequired,
    tempCurrency: PropTypes.string.isRequired,
    setTempCurrency: PropTypes.func.isRequired,
    trackSegmentButtonClick: PropTypes.func.isRequired,
    checkoutSubHeaderTextDigital: PropTypes.string,
    checkoutSubHeaderTextPhysical: PropTypes.string,
    checkoutSubHeaderTextPrintAtHome: PropTypes.string
};

const mapDispatchToProps = {
    saveSelectedCardOnBuyButtonClickAction: saveSelectedCardOnBuyButtonClick,
    categoryDropdownSelectClickAction: categoryDropdownSelectClick,
    saveSelectedCardType: selectedCardType,
    setCurrency: setCurrencyActionCreator,
    setClickedOnUYOAction: setClickedOnUYO,
    trackSegmentButtonClick: trackButtonClick
};

const mapStateToProps = state => ({
    remainingPlasticCardsAllowed: getRemainingPlasticCardsAllowed(state),
    cartMaxNumPlasticCards: getCartMaxNumPlasticCards(state),
    selectedCurrency: getIntlCurrencyCode(state),
    supportedElectronicCurrencyList: getBrandElectronicCurrencyList(state),
    supportedPlasticCurrencyList: getBrandPlasticCurrencyList(state),
    cartCurrencyCode: getCartCurrencyCode(state),
    uyoEgcPhotoSupported: getUYOEgcPhotoSupported(state),
    uyoPlasticPhotoSupported: getUYOPlasticPhotoSupported(state),
    selectedFaceplate: getSelectedFaceplate(state),
    checkoutSubHeaderTextDigital: getCheckOutSubHeaderTextDigital(state),
    checkoutSubHeaderTextPhysical: getCheckOutSubHeaderTextPhysical(state),
    checkoutSubHeaderTextPrintAtHome: getCheckOutSubHeaderTextPrintAtHome(state)
});
export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(windowSize(LandingPageFaceplateContainer)));
